<template>
  <BaseTable
      :title="$t('library_doc')"
      :subtractHeight="subtractHeight"
      :height="height"
      dto-model="LibraryDocListQueryDTO"
      dto-save-list-model="LibraryDocSaveListCommandDTO"
      store-name="LibraryDocTable"
      new-item-component="LibraryDocItem"
      new-item-pass="/LibraryDoc/LibraryDoc/LibraryDocItem"
      :lang-dictionary="function(text) {return $t(text)}"
      fixed-header
      :modal-dialog="modalDialog"
      :single-select="singleSelect"
      :actionSelected="actionSelected"
      @choice="$emit('choice', $event)"
  >
    <template v-slot:top.add="{instance}">
      <v-combobox
          v-model="library_topic"
          item-text="name"
          :label="$t('columns.library_topic')"
          :items="instance.itemListCommon.library_topics"
          dense
          clearable
          class="mt-4"
          :return-object="true"
          @change="onChangeLibraryTopic(instance)"
      >
      </v-combobox>
    </template>
    <template v-slot:item.uid="{ item }">
      <router-link :to="{name:'LibraryDocItem', params: { itemUid: item.uid}}">
        <span v-if="item.uid">{{ item.uid }}</span>
        <span v-else>****</span>
      </router-link>
    </template>
  </BaseTable>
</template>

<script>

import BaseTable from "@/components/Base/BaseTable";
import BaseDeleteIcon from "@/components/Base/BaseDeleteIcon";

export default {
  name: 'LibraryDocTable',
  props: {
    subtractHeight: {type: [Number], default: 140},
    height: {type: [Number], default: window.innerHeight},
    modalDialog: {type: [Boolean], default: false},
    singleSelect: {type: [Boolean], default: true},
    actionSelected: {default: false},
  },

  components: {
    BaseTable,
    BaseDeleteIcon,
  },

  computed: {},

  methods: {
    onChangeLibraryTopic(instance) {
      if (instance.filters === null)
        instance.filters = []
      if (!!this.library_topic) {
        instance.filters = instance.filters.filter(x => x.param_compare !== 'library_topic_id')
        instance.filters.push({param_compare: 'library_topic_id', value: this.library_topic.id})
      } else {
        instance.filters = instance.filters.filter(x => x.param_compare !== 'library_topic_id')
      }
      instance.onUpdateFilters()
    },

  },

  async mounted() {
    // console.log('mounted')
  },

  created() {
  },

  destroyed() {
  },

  beforeCreate() {
  },

  beforeDestroy() {
  },

  data() {
    return {
      library_topic: null,
    }
  }
}
</script>

<style>
.row_even {
}
</style>

<i18n>
{
  "en": {
    "search": "Search",
    "No data available": "No data available",
    "deleted": "Deleted",
    "library_doc": "Library documents",
    "columns": {
      "drag": " ",
      "deleted": " ",
      "edit": " ",
      "uid": "UUID",
      "name": "Name",
      "library_topic": "Library topic",
      "library_topic_name": "Library topic",
      "created_by": "Created by",
      "edited_by": "Edited by",
      "created_by_name": "Created by",
      "edited_by_name": "Edited by",
      "created_on": "Created on",
      "edited_on": "Edited on"
    },
    "Save": "Save",
    "Cancel": "Cancel",
    "New item": "New item"
  },
  "de": {
    "search": "Suche",
    "No data available": "Keine Daten verfügbar",
    "deleted": "Gelöscht",
    "library_doc": "Bibliotheksdokumente",
    "columns": {
      "drag": " ",
      "deleted": " ",
      "edit": " ",
      "uid": "UUID",
      "name": "Name",
      "library_topic": "Bibliotheksthemen",
      "library_topic_name": "Bibliotheksthemen",
      "created_by": "Erstellt von",
      "edited_by": "Bearbeitet von",
      "created_by_name": "Erstellt von",
      "edited_by_name": "Bearbeitet von",
      "created_on": "Erstellt am",
      "edited_on": "Bearbeitet am"
    },
    "Save": "Speichern",
    "Cancel": "Stornieren",
    "New item": "Neuer Artikel"
  }
}
</i18n>
